<template>
  <div class="addResourse">
    <div class="addResourse_head">
      <span @click="isHave = true" :class="{ 'isactive': isHave}">资源库</span>
      <span @click="isHave = false" :class="{ 'isactive': !isHave}">本地上传</span>
    </div>
    <transition name="el-zoom-in-center">
    <div v-show="isHave" class="addResourse_left">
      <knowledge-points @knowledgePointsNodeClick="knowledgePointsNodeClick" :subjectId="subjectId"></knowledge-points>
      <div style="flex: 1;position: relative">
        <el-table
          :data="tableData"
          style="margin-left: 10px;position: absolute"
          @row-click="rowClick"
          :height="`calc(100% - 60px)`"
          :cell-style="{ textAlign: 'left' }"
          :header-cell-style="{ textAlign: 'left' }"
        >
<!--          :header-cell-style="{ background: '#2b2a33', color: '#ffffff' }"-->
          <el-table-column label width="35">
            <template slot-scope="scope">
              <el-radio v-if="nodeKey === 'id'" :label="scope.row.id" v-model="currentValue">&nbsp;</el-radio>
              <el-radio v-if="nodeKey === 'url'" :label="scope.row.newAttaUrl" v-model="currentValue">&nbsp;</el-radio>
            </template>
          </el-table-column>

          <el-table-column prop="name" label="素材名称" >
            <template slot-scope="scope">
              <span v-if="scope.row.transcodeStatus == 2" style="color: red; padding-right: 5px;">[转码中]</span>
              <span
                v-else-if="scope.row.transcodeStatus == 3"
                style="color: red; padding-right: 5px;"
              >[转码失败]</span>
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column prop="createUseStr" label="上传人" width="130" >
            <template slot-scope="scope">
              <div
                style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
              >{{ scope.row.createUseStr}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :formatter="formatCreateTime" label="上传时间" width="120"></el-table-column>
          <div slot="empty" class="empty_material">
            <!-- <img src="../../../assets/image/sources/wujieguo.png" alt="加载失败"/> -->
            <p>该目录暂无素材</p>
          </div>
        </el-table>
        <Pagination
          style="position: absolute;bottom: 0;right: 0"
          :currentpage="pageTotal.currentPage"
          :limit="pageTotal.pageSize"
          :total="pageTotal.total"
          layout="sizes, prev, pager, next, jumper"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          :small="true"
        ></Pagination>
      </div>
    </div>
    </transition>
    <transition name="el-zoom-in-center">
      <div v-show="!isHave" class="addResourse_right">

        <div class="addResourse_right_content">
          <div class="right_content" style="margin-bottom: 40px">
            <span class="right_content_label">知识点</span>
            <el-cascader class="right_content_input"
                         ref="cascader"
                         placeholder="选择知识点"
                         :options="knowledgePoints"
                         v-model="selectPoints"
                         :props="{checkStrictly: true,expandTrigger: 'hover'}"
                         filterable
                         clearable
                         show-all-levels
            >
            </el-cascader>
          </div>
          <div class="right_content" style="margin-bottom: 15px">
            <span class="right_content_label">上传资源</span>
            <el-input class="right_content_input" placeholder="点击上传" v-model="materialForm.fileName">
              <el-upload slot="suffix"
                ref="addUpload"
                :action="materialForm.url"
                :data="materialForm.data"
                :headers="headers"
                :show-file-list="false"
                :with-credentials="true"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :on-progress="uploadProgress"
                multiple
              >
                <i class="el-input__icon el-icon-plus"></i>
              </el-upload>
            </el-input>
            <div v-if="progressFlag" class="upload_title">{{ materialForm.title }}</div>
            <el-progress v-if="progressFlag" class="upload_progress" :stroke-width="5" :percentage="loadProgress"></el-progress>
          </div>
          <p class="mjx" v-if="type === 7">支持png、jpg、jpeg格式10M以内</p>
          <p class="mjx" v-else-if="type === 8">支持doc、docx、ppt、pptx、pdf、xlsx格式</p>
          <p class="mjx" v-else-if="type === 9">支持mp3格式</p>
          <p class="mjx" v-else-if="type === 10">支持asx、asf、mpg、3gp、mp4、mov、avi、flv格式</p>

        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import * as api from "../../api/sourceApi";
import knowledgePoints from '../single_resource_course/components/knowledgePoints'
import Pagination from "@/components/paginator/paginator";
const formatData = data =>  data.length > 0? data.map(v => ({children: formatData(v.children), label: v.name, value: v.id})):undefined;
export default {
  name: "addResourse.vue",
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    subjectId: {
      type: [String, Number],
      default: 0,
    },
    type: {
      type: [String, Number],
      default: 0,
    },
    nodeKey:{
      type: String,
      default: 'id',
    }
  },
  components: {
    knowledgePoints,
    Pagination
  },
  data() {
    return {
      //  { 2021.7.8
      tableData: [],
      isHave: true, // 是否拥有想要的素材。没有就本地上传
      materialId: null,
      // 2021.7.9
      currentValue: this.value,
      //  }
      //条件查询
      conditionList: {
        //素材名称
        materialName: "",
        materialType: "",
        materialstate: "",
        userPhoneOrName: "",
        materialTypes: [
          { value: "1", label: "图片" },
          { value: "2", label: "文档" },
          { value: "3", label: "音频" },
          { value: "4", label: "视频" },
          { value: "5", label: "zip" },
        ],
        materialstates: [
          { value: "1", label: "通过" },
          { value: "2", label: "已驳回" },
          { value: "3", label: "待审核" },
        ],
        materialSubjectNames: [],
        materialSubjectName: "",
      },

      //分页数据
      pageTotal: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      // 本地上传 2021.7.23
      knowledgePoints:[],
      selectPoints: '',  // 知识点
      materialForm: {
        url: `${process.env.UPLOAD_NAME}/fileUpload/uploadFile`,
        data: {
          savepath: "cjdd/resourse/",
        },
        fileName:'',
        id:'',
      },
      showUploadFileList:[],
      loadProgress: 0,
      progressFlag:false,
    };
  },
  watch: {
    value(val) {
      this.currentValue = val;
    },
    currentValue(val) {
      this.$emit("input", val);
    },

    type: {
      handler() {
        this.postCollegeLists();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    headers() {
      return {
        Authorization: "bearer " + localStorage.getItem("Authorization"),
      };
    },
  },
  created() {
    let knowledgePoints = sessionStorage.getItem('knowledgePoints');
    if (knowledgePoints){
      this.knowledgePoints = formatData(JSON.parse(knowledgePoints));
    }
  },
  mounted() {},
  methods: {
    // 素材列表数据
    postCollegeLists() {
      this.tableData = [];
      let obj = {
        materialId: this.materialId,
        pageNum: this.pageTotal.currentPage,
        pageSize: this.pageTotal.pageSize,
        name: this.conditionList.materialName,
        type: this.filtersType(this.type),
        status: this.conditionList.materialstate,
        phoneOrName: this.conditionList.phoneOrName,
        subjectId: this.subjectId,
      };
      api
        .getMaterialList(obj, {
          method: "post",
        })
        .then((res) => {
          if (res.code == "0") {
            this.tableData = res.data.list;
            if (this.tableData.length > 0) {
              let { total, pageNum: currentPage, pageSize } = res.data;
              this.pageTotal = { total, currentPage, pageSize };
            } else {
              this.pageTotal = { currentPage: 1, pageSize: 10 };
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 选择知识点，查询素材
    knowledgePointsNodeClick(knowledgePoints){
      this.materialId = knowledgePoints.id;
      this.postCollegeLists();
    },
    handleCurrentChange(val) {
      this.pageTotal.currentPage = val || this.pageTotal.currentPage;
      this.postCollegeLists()
    },
    handleSizeChange(val){
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      this.postCollegeLists()
    },
    filtersType(type) {
      switch (type) {
        case 7:
          return 1;
        case 8:
          return 2;
        case 10:
          return 4;
        default:
          return "";
          break;
      }
    },
    beforeAvatarUpload(file, fileList){
      let userId = sessionStorage.getItem("userId");
      let orgId = sessionStorage.getItem("deptId");
      let materialName = "";
      this.$set(this.headers, 'subjectId', this.subjectId)
      if(this.$refs['cascader'].getCheckedNodes(false).length ==0){
        materialName="全部";
        // this.$set(this.headers, 'subjectId', this.materialObjData.id)
      }else {
        let  materialId = this.$refs['cascader'].getCheckedNodes(false)[0].value;
        materialName = this.$refs['cascader'].getCheckedNodes(false)[0].label;
        this.$set(this.headers, 'materialId', materialId)
        // this.$set(this.headers, 'subjectId', this.materialObjData.id)
      }
      this.$set(this.headers, 'userId', userId)
      this.$set(this.headers, 'orgId', orgId)
      let fileSize = file.size;
      let name = file.name;
      if (name.length > 200) {
        this.$message.warning("名字长度过长,请重新选择");
        return;
      }
      let suffix = name.substring(name.lastIndexOf(".") + 1);
      let docArr = ["docx","DOCX","doc", "DOC", "ppt", "PPT", "pptx", "PPTX", "pdf", "PDF", "xlsx", "XLSX", ];
      let auditArr  = ["mp4","MP4","avi","AVI","asx","ASX","asf","ASF","mpg","MPG","3gp","3GP","mov","MOV","avi","AVI","flv","FLV"]
      if (docArr.indexOf(suffix) != -1) {
        if (fileSize > 104857600) {
          this.$message.warning("上传文件不能大于100M");
          return;
        }
        //上传类型 2 文档
        let {name,size,uid} =file;
        let obj = {name,size,uid,state:"上传中",img:require('../../../static/images/newCourseImages/wd@2x.png'),materialName,file};
        this.showUploadFileList.push(obj);

      } else if (auditArr.indexOf(suffix) != -1) {
        if (fileSize > 2147483648) {
          //2147483648 2G
          this.$message.warning("上传视频文件不能大于2G");
          return;
        }

        //上传类型 4  视频
        let {name,size,uid} =file;
        let obj = {name,size,uid,state:"上传中",img:require('../../../static/images/newCourseImages/sp@2x.png'),materialName,file};
        this.showUploadFileList.push(obj);

      } else if (suffix == "mp3") {
        if (fileSize > 31457280) {
          //31457280 2G
          this.$message.warning("上传音频文件不能大于30M");
          return;
        }

        //上传类型 3  音频
        let {name,size,uid} =file;
        let obj = {name,size,uid,state:"上传中",img:require('../../../static/images/newCourseImages/yp@2x.png'),materialName,file};
        this.showUploadFileList.push(obj);
      } else if (suffix == "jpg" || suffix == "png" || suffix == "jpeg") {
        if (fileSize > 10485760) {
          //104857600 10M
          this.$message.warning("上传图片不能大于10M");
          return;
        }
        //上传类型 1  图片
        let {name,size,uid} =file;
        let obj = {name,size,uid,state:"上传中",img:require('../../../static/images/newCourseImages/tp@2x.png'),materialName,file};
        this.showUploadFileList.push(obj);
      } else if (suffix == "zip") {
        if (fileSize > 104857600) {
          //104857600 100M
          this.$message.warning("上传压缩包不能大于100M");
          return;
        }
        this.materialForm.data.savepath = "course_res_/socialTraining/";
        let {name,size,uid} =file;
        let obj = {name,size,uid,state:"上传中",img:require('../../../static/images/newCourseImages/ceyan-3@2x.png'),materialName,file};
        this.showUploadFileList.push(obj);
      }

    },
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {

        this.materialForm.fileName = res.data.name;
        this.materialForm.id = res.data.id;
        this.materialForm.title = '上传成功';

        if (this.nodeKey === 'id'){
          this.currentValue = res.data.id;
        }else if(this.nodeKey === 'url'){
          this.currentValue = res.data.newAttaUrl;
        }

      } else {
        let fileId = file.uid;
        this.showUploadFileList.forEach(item =>{
          if(item.uid == fileId){
            item.state="上传失败";
          }
        })
        this.$message.error("格式不支持上传")
      }
    },
    uploadProgress(event, file) {
      this.progressFlag = true; // 显示进度条
      this.materialForm.title = '正在上传';
      this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
      if (this.loadProgress >= 100) {
        this.loadProgress = 100
       let timer = setTimeout( () => {
         this.progressFlag = false
         clearTimeout(timer)
       }, 2000) // 一秒后关闭进度条
      }
    },
    formatCreateTime(item) {
      if (!item || !item.createTime) return "";
      var date = new Date(item.createTime);
      var fmt = "yyyy-MM-dd";
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },
    rowClick(row) {
      if (this.nodeKey === 'id'){
        this.currentValue = row.id;
      }else if(this.nodeKey === 'url'){
        this.currentValue = row.newAttaUrl;
      }
    },
  },
};
</script>
<style scoped lang="scss">
  .addResourse{
    /*height: calc(100% - 122px);*/
    height: 100%;
    width: 100%;
    color: #2B2A33;
    overflow: hidden;
    .addResourse_head{
      height: 75px;
      line-height: 105px;
      border-bottom: solid 2px #2B2A33;
      span{
        display: inline-block;
        width: 100px;
        text-align: center;
        cursor: pointer;
      }
      .isactive{
        font-size: 19px;
        font-weight: 600;
      }
    }
    .addResourse_left,
    .addResourse_right
    {
      height: calc(100% - 86px);
      display: flex;
      padding-top: 10px;
      width: 100%;
      overflow: hidden;
    }
    .addResourse_right{
      position: relative;
      .addResourse_right_content{
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        .right_content{
          display: flex;
          /*height: 40px;*/
          line-height: 40px;
          position: relative;
          .right_content_label{
            width: 100px;
            background: #2B2A33;
            color: #ffffff;
            text-align: center;
            margin-right: -5px;
            z-index: 20;
            border-radius: 4px 0 0 4px;
          }
          .right_content_input{
            width: 400px;
          }
          .el-icon-plus{
            cursor: pointer;
            &:hover{
              color: #409EFF;
            }
          }
          .el-upload__text{
            height: 29px;
            width: 360px;
            background: red;
            position: absolute;
            right: 30px;
            top: 7px;
            opacity: 0;
            border-radius:0 4px  4px 0;
          }
          .upload_title{
            height: 40px;
            line-height: 40px;
            width: 100px;
            position: absolute;
            right: -100px;
            top: 0px;
            color: #007CED;
          }

          .upload_progress{
            width: 395px;
            position: absolute;
            right: 0px;
            top: 40px;
          }
        }
        .mjx{
          text-indent: 110px;
          color: #6D6C6E;
          padding: 4px 0;
          font-weight: 400;
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/component/addResourse.vue